<script>
import CustomerService from "@/store/services/customer.service";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountContact",
  extends: TotalAmountsBase,
  methods:{
    getTotalAmounts(){
      this.loading = true
      CustomerService.getCount(this.filters).then((response) => {
        this.loading = false
        this.amountsList = [];
        this.amountsList.push({text: this.$gettext("TOTAL"), amount: response.data, class:'green'});
      });
    }
  }
}
</script>